import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';
import { ServerService } from '../../../../service/server/server.service';
import { SearchMaterialComponent } from '../../search-material/search-material.component';
import { Financial2DetaileComponent } from '../../../finance/financial2/financial2-detaile/financial2-detaile.component';
import { ChequeDetaileComponent } from '../../../finance/cheque/cheque-detaile/cheque-detaile.component';


@Component({
  selector: 'app-order-detaile',
  templateUrl: './order-detaile.component.html',
  styleUrls: ['./order-detaile.component.scss']
})
export class OrderDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  search_array: any = [];
  reception_id: number | undefined;
  trash: number;

  sum_order_material: number = 0;
  sum_exit_material: number = 0;
  status_id_temp: number | undefined;
  status_id_add: number | undefined;
  currency_title: string | undefined;
  ref: string | undefined;
  invoice_id: number | undefined;
  token: any;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<OrderDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.trash = dialog_data.trash;
      this.type_task = dialog_data.type_task;
      this.ref = dialog_data.ref;
      this.invoice_id = dialog_data.invoice_id;
      this.create_form1();
      this.id = dialog_data.id;
      this.ref = dialog_data.ref;
      this.reception_id = dialog_data.reception_id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      this.token = dialog_data.token;
      if (this.type_task == 1) {
        this.get_status();
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          material: dialog_data.search_array.material,
          material_title: dialog_data.search_array.material_title,
          number: dialog_data.search_array.number,
          status_title: dialog_data.search_array.status_title,
          status_id: dialog_data.search_array.status_id,
          invoice_title: dialog_data.search_array.invoice_title,
          invoice: dialog_data.search_array.invoice,
          comment: dialog_data.search_array.comment,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'comment': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'number': new FormControl(1, [Validators.pattern('[0-9]{1,}')]),
      'material_title': new FormControl(null),
      'material': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cost': new FormControl(0),
      'invoice_title': new FormControl(null),
      'invoice': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['material'].setValidators([Validators.required]);
      this.form1_group.controls['number'].setValidators([Validators.required]);
      this.form1_group.controls['status_id'].setValidators([Validators.required]);
      this.form1_group.controls['cost'].setValidators([Validators.required]);
    }
    if (this.type_task == 1) {

    }

  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }

    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.check_for_update1(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      material: this.form1_group.value.material,
      material_title: this.form1_group.value.material_title,
      number: this.form1_group.value.number,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      invoice: this.form1_group.value.invoice,
      invoice_title: this.form1_group.value.invoice_title,
      comment: this.form1_group.value.comment,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6007, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              'title': res['result'][0].wharehouse_order_title,
              'cost': res['result'][0].wharehouse_order_cost,
              'comment': res['result'][0].wharehouse_order_comment,
              'material_title': res['result'][0].wharehouse_material_title,
              'material': res['result'][0].wharehouse_material_id,
              'invoice_title': res['result'][0].wharehouse_invoice_title,
              'invoice': res['result'][0].wharehouse_invoice_number,
              'number': res['result'][0].wharehouse_order_number,
              'sort': res['result'][0].wharehouse_order_sort,
              'status_id': res['result'][0].wharehouse_order_status,
              'status_title': res['result'][0].wharehouse_order_status_title,

            });
            this.currency_title = res['result'][0].site_currency_title;
            this.status_id_temp = res['result'][0].wharehouse_order_status_add;
            this.status_id_add = res['result'][0].wharehouse_order_status_add;
          }//end if
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6008, "user_id": this.user_id, 'status_id': this.form1_group.value.status_id
      , 'comment': this.form1_group.value.comment
      , 'material': this.form1_group.value.material
      , 'number': this.form1_group.value.number
      , 'invoice': this.form1_group.value.invoice
      , 'cost': this.form1_group.value.cost
      , 'sort': this.form1_group.value.sort
      , reception_id: this.reception_id
      , 'invoice_id': this.invoice_id
      , 'token': this.token
      , 'material_type': 1
      , 'trash': this.trash
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  check_for_update() {
    if (this.status_id_temp == 1) {
      this.check_for_update1();
    } else {
      this.update();
    }
  }

  check_for_update1() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6003, material: this.form1_group.value.material, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.sum_order_material = Number(res['result'][0].inventory);
          if (this.status_id_add == 1) { this.sum_order_material += Number(this.form1_group.value.number); }
          if (this.sum_order_material >= 0) {
            this.update();
          } else {
            var pe_message = "تعداد خروجی های یک کالا نمی تواند بیشتر از ثبت ورودی ها باشد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6010, "user_id": this.user_id
      , 'comment': this.form1_group.value.comment
      , 'material': this.form1_group.value.material
      , 'number': this.form1_group.value.number
      , 'cost': this.form1_group.value.cost
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'token': this.token
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6011 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              status_id: res['result'][0].wharehouse_order_status_id,
              status_title: res['result'][0].wharehouse_order_status_title,
            })
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_goods_status(id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6012, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.status_id_add = res['result'][0].wharehouse_order_status_add;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_material() {
    const dialogRef = this.dialog.open(SearchMaterialComponent, {
      width: '45rem',
      height: 'auto',
      data: { invoice_id: this.id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          console.log(res)
          this.form1_group.patchValue({
            'material_title': res.title,
            'material': res.id
          });
          this.get_cost(res.id);
        }
      }
    )
  }

  get_cost(id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6013, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              'number': res['result'][0].wharehouse_order_number,
              'cost': res['result'][0].wharehouse_order_cost
            })
          } else {
            this.form1_group.patchValue({
              'number': 0,
              'cost': 0
            })
          }

          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  } 


  load_services(id: number) {
    var where = "";
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, where: where }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 158) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            });
            this.get_goods_status(res.id);
          }
          if (id == 171) {
            this.form1_group.patchValue({
              'material': res.id,
              'material_title': res.title
            })
          }
          if (id == 154) {
            this.form1_group.patchValue({
              'material_title': null,
              'material': null
            })
          }
          if (id == 184) {
            this.form1_group.patchValue({
              'material_title': null,
              'material': null
            })
          }
          if (id == 188) {
            this.form1_group.patchValue({
              'invoice': res.id,
              'invoice_title': res.title
            });
            this.get_currency_title();
          }
        }
      }
    )
  }

  get_currency_title() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6014, 'invoice': this.form1_group.value.invoice }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.currency_title = res['result'][0].site_currency_title;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 158) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 171) {
      this.form1_group.patchValue({
        'material': null,
        'material_title': null,
      })
    }
    if (id == 154) {
      this.form1_group.patchValue({
        'material': null,
        'material_title': null,
      })
    }
    if (id == 184) {
      this.form1_group.patchValue({
        'material': null,
        'material_title': null,
      })
    }
    if (id == 188) {
      this.form1_group.patchValue({
        'invoice': null,
        'invoice_title': null,
      });
      this.currency_title = "";
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

